<div class="timeline-tooltip">
  <span class="title">{{ tooltipTitle }}</span>
  @for(event of processedEvents; track event.label;) {
  <div class="timeline-tooltip-row">
    <div class="milestone-progress-indicator" [ngClass]="event.status">
      @if (event.status !== "incomplete") {
      <mat-icon class="icon">
        {{ event.status === 'complete' ? 'done' : null }}
        {{ event.status === 'error' ? 'close' : null }}
      </mat-icon>
      }
    </div>
    <div class="timeline-tooltip-label">{{ event.label | titlecase }}: </div>
    <div class="timeline-tooltip-date">{{ event?.timestamp ? (event.timestamp * 1000 | date : 'MMMM d, y h:mm a') : null}}</div>
  </div>
  }
</div>